import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

//ANT DESIGN IMPORTS
import {
  Row,
  Card,
  Form,
  DatePicker,
  Button,
  Input,
  Modal,
  Select,
  Tooltip,
  Table,
  Col,
  Divider,
  Spin
} from "antd";

//ANT DESIGN ICONS IMPORTS
import { FolderOpenOutlined, EditOutlined } from "@ant-design/icons";

//OTHER IMPORTS
import dayjs from 'dayjs';

//PROJECT IMPORTS
import { BOM } from "../../../../services/definedMethod";
import cnt from "../../../../services/definedConstant";
import CustomButton from "../../../../components/custom/CustomButton";
import MainLayout from "../../../../components/layouts/MainLayout";
import TopContent from "../../../../components/layouts/TopContent";
import { apiConfig, labelConfig, staticConfig } from "../../group.config";
import { accountStatus } from "../../../../components/facilities/AccountFacility";
import styles from "../../../../assets/styles/styles";
import { log } from "@antv/g2plot/lib/utils";


const Attendance = (props) => {
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { state } = useLocation();
  const [membersTableSource, setMembersTableSource] = useState([]);
  const [attendanceOptions, setAttendanceOptions] = useState([]);
  const [nextMeetingDate, setNextMeetingDate] = useState();
  const [attendanceDetails, setAttendanceDetails] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const dateFormat = 'YYYY/MM/DD';


  useEffect(() => {
    getDetailById();
  }, []);

  const getDetailById = () => {
    const params = {
      associations: "all",
    };

    const url = `${apiConfig.Groups}/${state.id}`;

    let body = {
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        setAttendanceDetails(objDetail);
        setNextMeetingDate(BOM.FormatArrayDate(objDetail?.collectionMeetingCalendar?.nextTenRecurringDates[0]))
        getMeetingTemplate(objDetail?.collectionMeetingCalendar?.id)
        setIsLoading(false);
      }
    });
  };

  const getMeetingTemplate = (calenderId) => {
    const params = {
      calenderId,
    };
    console.log(attendanceDetails?.collectionMeetingCalendar?.id);

    const url = `${apiConfig.Groups}/${state.id}/meetings/template`;

    let body = {
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        let tempMembersTableSource = [];
        let tempAttendanceOptions = [];

        objDetail?.clients?.forEach((element) => {
          tempMembersTableSource.push({
            name: element?.displayName,
            attendance: objDetail?.attendanceTypeOptions[0]?.value,
            id: element?.id,
            key: element?.id,
          });
        });

        objDetail?.attendanceTypeOptions?.forEach((element) => {
          tempAttendanceOptions.push({
            value: element?.id,
            label: element?.value,
          });
        });

        form.setFieldsValue({
          meetingDate: dayjs()
        });

        setMembersTableSource(tempMembersTableSource);
        setAttendanceOptions(tempAttendanceOptions);
        setIsLoading(false);

      }
    });
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "Attendance",
      dataIndex: "attendance",
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) =>
        <EditAttendance
          selectedRecord={record}
          attendanceOptions={attendanceOptions}
          membersTableSource={membersTableSource}
          setMembersTableSource={setMembersTableSource}
        />
    },
  ];

  function onCancel() {
    navigate("/detail-group", { state: state });
  }

  const onSubmit = (formValues) => {
    const url = `${apiConfig.Groups}/${state.id}/meetings`;
    const params = {
      calendarId: attendanceDetails?.collectionMeetingCalendar?.id,
    };
    formValues.meetingDate = BOM.DateTime(
      formValues.meetingDate,
      "only-date"
    );
    formValues.calendarId = attendanceDetails?.collectionMeetingCalendar?.id;
    let tempClientsAttendance = [];

    formValues.clientsAttendance = membersTableSource.forEach(element =>
      tempClientsAttendance.push(
        {
          attendanceType: element?.attendance && attendanceOptions.find(item =>
            item.label === element?.attendance
          )?.value,
          clientId: element?.id
        }
      )
    );

    formValues.clientsAttendance = tempClientsAttendance;

    const body = {
      ...formValues,
      dateFormat: "dd MMMM yyyy",
      locale: "en",
      method: "POST",
      session,
      params,
    };
    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, labelConfig.grpAttendanceMsg);
        navigate("/detail-group", {
          state: { ...state, statusValue: accountStatus.active },
        });
        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  return (
    <MainLayout isEnableRightSidebar={true}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.attendance}
        pageItems={staticConfig.grpAttendanceBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form form={form} layout="vertical" onFinish={onSubmit}>
            <Row>
              <Divider orientation="left">{`Account No: ${state.accountNo}`}</Divider>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label="Meeting Date"
                  name="meetingDate"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.date),
                    },
                  ]}
                >
                  <DatePicker
                    style={{ width: "100%", height: 35 }}
                    format={dateFormat}
                  />
                </Form.Item>
              </Col>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label="Next Meeting on"
                >
                  <Input
                    disabled
                    className="of-bold-disable-input"
                    value={nextMeetingDate}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Table
              columns={columns}
              dataSource={membersTableSource}
              bordered
              pagination={{
                position: "bottomCentre",
                pageSize: "10",
              }}
            />
            <Row>
              <Divider />
              {BOM.HasPermission("SAVEORUPDATEATTENDANCE_MEETING") &&
                <CustomButton
                  content="Submit"
                  style={{
                    width: "10%",
                    marginLeft: "auto",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  htmlType="submit"
                  backgroundColor="#92428B"
                  colorText="white"
                  hoverBackground="#AD4EA7"
                />}

              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};
export default Attendance;

const EditAttendance = (props) => {
  const {
    selectedRecord,
    membersTableSource,
    setMembersTableSource,
    attendanceOptions,
  } = props;

  const [useForm] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onSubmit = (values) => {

    values.key = selectedRecord?.key;
    values.attendance = attendanceOptions.find(
      item => item?.value === values?.attendance
    )?.label;

    const editedAttendance = membersTableSource.map(item =>
      item.key === values.key ? { ...item, ...values } : item
    );
    setMembersTableSource(editedAttendance);
    setIsModalOpen(false);
  };

  return (
    <>
      <Tooltip title="Edit Attendance">
        <Button
          type="primary"
          icon={<EditOutlined />}
          onClick={showModal}
          shape="round"
          size="small"
          className="of-primaryBtnColor"
        />
      </Tooltip>
      <Modal
        title="Edit Attendance"
        open={isModalOpen}
        okText="Submit"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form layout="vertical" form={useForm} onFinish={onSubmit}>
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Row>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              name="attendance"
              label="Attendance"
              rules={[
                {
                  required: true,
                  message: BOM.CheckReqFld(labelConfig.attendance),
                },
              ]}
            >
              <Select
                placeholder={"Please select a value"}
                options={attendanceOptions}
                showSearch
              />
            </Form.Item>
          </Col>
        </Row>

      </Modal>
    </>
  );
};
